import type { LucideIcon } from 'lucide-react'
import {ArrowUpRight} from 'lucide-react'

interface AffiliateCardProps {
  icon: LucideIcon
  name: string
  tagline: string
  cta: string
  accent?: 'emerald' | 'teal' | 'cyan' | 'amber'
}

const accentBg: Record<string, string> = {
  emerald: 'bg-emerald-500/10 text-emerald-400',
  teal: 'bg-teal-500/10 text-teal-400',
  cyan: 'bg-cyan-500/10 text-cyan-400',
  amber: 'bg-amber-500/10 text-amber-400',
}

function AffiliateCard({ icon: Icon, name, tagline, cta, accent = 'emerald' }: AffiliateCardProps) {
  return (
    <div className="group flex items-center justify-between gap-3 rounded-xl border border-slate-800 bg-slate-900/60 p-4 transition-colors hover:border-slate-700">
      <div className="flex items-center gap-3">
        <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${accentBg[accent]}`}>
          <Icon className="h-5 w-5" />
        </span>
        <div>
          <p className="text-sm font-semibold text-slate-100">{name}</p>
          <p className="text-xs text-slate-500">{tagline}</p>
        </div>
      </div>
      <span className="flex items-center gap-1 whitespace-nowrap rounded-lg border border-slate-700 px-3 py-1.5 text-xs font-semibold text-slate-300 transition-colors group-hover:border-emerald-500 group-hover:text-emerald-400">
        {cta}
        <ArrowUpRight className="h-3 w-3" />
      </span>
    </div>
  )
}

export default AffiliateCard
